import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	ddnyTitle,
} from '../../../../utils/ddny';

import styles from './_styles/ProductSelector.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class ProductSelector extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {

			inputQuery: this.props.currentSelection?.vendor_style || '',

			errorQuery: '',

			requestPending: false,
			requestError: '',

			autocompleteOpen: false,
			autocompleteResults: [],
		};

		this.AUTOCOMPLETE_INPUT_COUNT = 3;

		this.controller = null;

		this.checkClick = this.checkClick.bind(this);

		this.autocompleteRef = React.createRef();
	}

	componentDidMount() {
		window.addEventListener('click', this.checkClick, false);
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.checkClick, false);
		if(this.controller) {
			this.controller.abort();
		}
	}

	checkClick(evt) {
		if(this.state.autocompleteOpen) {
			
			let targetElement = evt.target;
			do {
				if(targetElement === this.autocompleteRef.current) {
					return;
				}
				targetElement = targetElement.parentNode;

			} while(targetElement);
	  
			// This is a click outside, should close
			this.setState({ autocompleteOpen: false });
		}
	}

	async searchProducts() {
		if(this.state.inputQuery.length >= this.AUTOCOMPLETE_INPUT_COUNT) {

			if(this.controller) {
				this.controller.abort();
			}
			const controller = new AbortController();
			this.controller = controller;
			
			try {

				this.setState({
					requestPending: true,
					errorQuery: '',
				});

				const requestData = {
					q: this.state.inputQuery,
					page: 1,
					size: 5,
				};

				const autocompleteData = await this.props.ddnyFetchAutocompletePage(requestData, controller.signal);

				this.setState({
					autocompleteOpen: true,
					autocompleteResults: autocompleteData.data,
				});

			} catch(err) {

				if(controller.signal.aborted) { return null; }
				
				// Handle the error
				console.error(err);
				this.setState({ requestError: 'Error fetching products' });

			} finally {
				this.setState({ requestPending: false });
			}
		}
	}

	handleChange(evt) {
		this.setState({
			inputQuery: evt.target.value,
		}, () => {
			if(this.state.inputQuery.length >= this.AUTOCOMPLETE_INPUT_COUNT) {
				this.searchProducts();
			}
		});
	}

	handleSelect(item) {
		this.setState({
			inputQuery: item.vendor_style || '',
			autocompleteOpen: false,
			autocompleteResults: [],
		}, () => {
			if(this.props.onSelect) {
				this.props.onSelect(item);
			}
		});
	}

	handleFocus() {
		if(this.state.inputQuery.length >= this.AUTOCOMPLETE_INPUT_COUNT) {
			this.searchProducts();
		}
	}
	
	render() {
		return <div className={`${styles.ProductSelector}`}>
			<div ref={this.autocompleteRef} className={styles.inputWrapper}>
				<input 
					type="text" 
					value={this.state.inputQuery} 
					onChange={(evt) => this.handleChange(evt)} 
					onFocus={this.handleFocus.bind(this)}
					placeholder="Enter SKU or style number" 
					className={styles.inputField} />
				<div className={`${styles.autoCompleteWrapper} ${this.state.autocompleteOpen ? styles.open : ''}`}>
					<div className={`${styles.autoCompleteDrawer}`}>
						{this.state.autocompleteResults.length > 0
							? 	this.state.autocompleteResults.map((item, i) => {
									return <div 
										key={i} 
										className={styles.autoCompleteItem} 
										onClick={() => this.handleSelect(item)}>
										{ddnyTitle(item)}
									</div> 
								})
							: 	<div className={styles.noResults}>No results found</div>
						}
					</div>
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ProductSelector);